module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"reportSubTitle":"LightFileシミュレーションレポート","usingWebp":"WebP導入済み","usingLightFile":"画像軽量化済み"}}')
  delete Component.options._Ctor
}
